import CountItemPayload from '@/models/payloads/CountItemPayload';

const entities: CountItemPayload[] = [
  {
    name: 'Affair',
    label: 'Affaires',
    description: 'Nombre total d\'Affaires',
  },
  {
    name: 'Session',
    label: 'Sessions',
    description: 'Nombre total de Sessions',
  },
  {
    name: 'Protocol',
    label: 'Protocoles',
    description: 'Nombre total de Protocoles',
  },
  {
    name: 'Region',
    label: 'Régions',
    description: 'Nombre total de Régions',
  },
  {
    name: 'Taxref',
    label: 'Taxrefs',
    description: 'Nombre total de Taxrefs',
  },
  {
    name: 'User',
    label: 'Utilisateurs',
    description: 'Nombre total de Utilisateurs',
  },
  {
    name: 'Habitat',
    label: 'Habitats',
    description: 'Nombre total de Habitats',
  },
];
const species: CountItemPayload[] = [
  {
    name: 'Avifaune',
    label: 'Avifaune',
    description: 'Nombre total d\'Avifaunes',
  },
  {
    name: 'Chiropteres',
    label: 'Chiropteres',
    description: 'Nombre total de Chiropteres',
  },
  {
    name: 'Coleopteres',
    label: 'Coleopteres',
    description: 'Nombre total de Coleopteres',
  },
  {
    name: 'Lepidopteres',
    label: 'Lepidopteres',
    description: 'Nombre total de Lepidopteres',
  },
  {
    name: 'MammiferesHorsChiro',
    label: 'MammiferesHorsChiro',
    description: 'Nombre total de Mammiferes hors chiro',
  },
  {
    name: 'Odonate',
    label: 'Odonate',
    description: 'Nombre total de Odonate',
  },
  {
    name: 'Reptiles',
    label: 'Reptiles',
    description: 'Nombre total de Reptiles',
  },
  {
    name: 'PatrimonialFloraSpecies',
    label: 'PatrimonialFloraSpecies',
    description: 'Nombre total de PatrimonialFloraSpecies',
  },
  {
    name: 'Amphibian',
    label: 'Amphibian',
    description: 'Nombre total de Amphibian',
  },
];
const coordinates: CountItemPayload[] = [
  {
    name: 'Point',
    label: 'Point',
    description: 'Nombre total de Points',
  },
  {
    name: 'Polygone',
    label: 'Polygone',
    description: 'Nombre total de Polygones',
  },
  {
    name: 'Polyligne',
    label: 'Polyligne',
    description: 'Nombre total de Polylignes',
  },
];

export function findEntities(): CountItemPayload[] {
  return entities;
}
export function findEntity(name: string): CountItemPayload | undefined {
  return entities.find((item) => item.name === name);
}

export function findSpecies(): CountItemPayload[] {
  return species;
}

export function findSpecie(name: string): CountItemPayload | undefined {
    return species.find((item) => item.name === name);
  }

export function findCoordinates(): CountItemPayload[] {
  return coordinates;
}

export function findCoordinate(name: string): |CountItemPayload | undefined {
    return coordinates.find((item) => item.name === name);
  }
